import { Component, OnInit } from '@angular/core';
import { AppService } from 'app/app.service';
import { Router } from '@angular/router';
import { DomainStorageProvider } from 'providers/domain-storage/domain-storage';
import { TranslationProvider } from 'providers/translation/translation';

@Component({
    selector: 'app-tips',
    templateUrl: './tips.component.html',
    styleUrls: ['./tips.component.scss']
})
export class TipsComponent implements OnInit {

    constructor(
        private router: Router,
        private appService: AppService,
        private domainStorageProvider: DomainStorageProvider,
        public translationProvider: TranslationProvider,
    ) {
        this.showHideMenu(false);
    }

    tips: any[];

    ngOnInit() {
        this.tips = this.domainStorageProvider.rootStore.tips;
    }

    ngOnDestroy() {
        this.showHideMenu(true);
    }

    showHideMenu(show) {
        this.appService.onMainMenuEvent.emit(show);
    }

    back() {
        this.router.navigate(["/"]);
    }
}
